import { combineReducers } from 'redux';

import {
  createJiraIssueReducer as createJiraIssue,
  CreateJiraIssueState,
} from './create-jira-issue';
import {
  dashboardJiraIssuesReducer as dashboardJiraIssues,
  DashboardJiraIssuesState,
} from './dashboard-jira-issues';
import {
  jiraMigrationReducer as jiraMigration,
  JiraMigrationState,
} from './jira-migration';
import {
  jiraRepoPageReducer as jiraRepoPage,
  RepositoryJiraState,
} from './jira-repo-page';
import {
  pullRequestJiraIssuesReducer as pullRequestJiraIssues,
  PullRequestJiraIssuesState,
} from './pull-request-jira-issues';

export type JiraState = {
  jiraRepoPage: RepositoryJiraState;
  createJiraIssue: CreateJiraIssueState;
  pullRequestJiraIssues: PullRequestJiraIssuesState;
  dashboardJiraIssues: DashboardJiraIssuesState;
  jiraMigration: JiraMigrationState;
};

export const jiraReducer = combineReducers({
  jiraRepoPage,
  createJiraIssue,
  pullRequestJiraIssues,
  dashboardJiraIssues,
  jiraMigration,
});
